export const REQUEST_MAPPINGS = 'dt/item-designation/REQUEST_MAPPINGS';
export const RECEIVE_MAPPINGS = 'dt/item-designation/RECEIVE_MAPPINGS';
export const RECEIVE_MAPPING = 'dt/item-designation/RECEIVE_MAPPING';
export const CREATE_MAPPING = 'dt/item-designation/CREATE_MAPPING';
export const CREATE_MAPPINGS = 'dt/item-designation/CREATE_MAPPINGS';
export const CREATE_GEOMETRIES_MAPPINGS = 'dt/item-designation/CREATE_GEOMETRIES_MAPPINGS';
export const UPDATE_OR_DELETE_MAPPINGS = 'dt/item-designation/UPDATE_OR_DELETE_MAPPINGS';
export const UPDATE_MAPPING = 'dt/item-designation/UPDATE_MAPPING';
export const DELETE_MAPPING = 'dt/item-designation/DELETE_MAPPING';
export const IMPORTED_MAPPING_AT = 'dt/item-designation/IMPORT_SUCCESS_AT';
export const RESET_MAPPINGS_IMPORTED_AT = 'dt/item-designation/RESET_MAPPINGS_IMPORTED_AT';
export const MAPPINGS_IMPORT_ERRORS = 'dt/item-designation/MAPPINGS_IMPORT_ERRORS';
export const REQUEST_GEOMETRIES = 'dt/geometry/REQUEST_GEOMETRIES';
export const RECEIVE_GEOMETRIES = 'dt/geometry/RECEIVE_GEOMETRIES';
export const CREATE_GEOMETRY_OR_UPDATE = 'dt/geometry/CREATE_GEOMETRY';
export const DELETE_GEOMETRY = 'dt/geometry/DELETE_GEOMETRY';

export const requestMappings = (siteId, { callback, modelId, versionId } = {}) => ({
  type: REQUEST_MAPPINGS,
  siteId,
  callback,
  modelId,
  versionId,
});

export const receiveMappings = (siteId, mappings) => ({
  type: RECEIVE_MAPPINGS,
  siteId,
  mappings,
});

export const receiveMapping = (siteId, modelId, mapping) => ({
  type: RECEIVE_MAPPING,
  siteId,
  modelId,
  mapping,
});

export const updateMapping = (siteId, modelId, versionId, mapping, callback) => ({
  type: UPDATE_MAPPING,
  siteId,
  modelId,
  versionId,
  mapping,
  callback,
});

export const createMapping = (siteId, modelId, versionId, mapping, callback) => ({
  type: CREATE_MAPPING,
  siteId,
  modelId,
  versionId,
  mapping,
  callback,
});

export const createMappings = (siteId, modelId, versionId, mappings) => ({
  type: CREATE_MAPPINGS,
  siteId,
  modelId,
  versionId,
  mappings,
});

export const createGeometriesAndMappings = (siteId, documentsWithShapes) => ({
  type: CREATE_GEOMETRIES_MAPPINGS,
  siteId,
  documentsWithShapes,
});

export const updateOrDeleteMappings = (siteId, modelId, versionId, scope, callback) => ({
  type: UPDATE_OR_DELETE_MAPPINGS,
  siteId,
  modelId,
  versionId,
  scope,
  callback,
});

export const deleteMapping = (siteId, modelId, versionId, mappingId) => ({
  type: DELETE_MAPPING,
  siteId,
  modelId,
  versionId,
  mappingId,
});

export const requestGeometries = (siteId, modelId, callback) => ({
  type: REQUEST_GEOMETRIES,
  siteId,
  modelId,
  callback,
});

export const receiveGeometries = (siteId, modelId, geometries) => ({
  type: RECEIVE_GEOMETRIES,
  siteId,
  modelId,
  geometries,
});

export const createOrUpdateGeometry = (siteId, modelId, geometries, callback) => ({
  type: CREATE_GEOMETRY_OR_UPDATE,
  siteId,
  modelId,
  geometries,
  callback,
});

export const deleteGeometry = (siteId, modelId, geometryId, callback) => ({
  type: DELETE_GEOMETRY,
  siteId,
  modelId,
  geometryId,
  callback,
});

export const mappingsImportedAt = () => ({
  type: IMPORTED_MAPPING_AT,
  importedAt: Date.now(),
});

export const resetImportedMappingsAt = () => ({
  type: RESET_MAPPINGS_IMPORTED_AT,
});

export const setImportErrors = (errors) => ({
  type: MAPPINGS_IMPORT_ERRORS,
  errors,
});
